import { Box, Button, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import RateTable from '../components/RateTable';
import rateApi from '../api/rate';
import dayjs from 'dayjs';
import { IMappedRate } from '../interface/IRate';
import { useToast } from '../helper/ToastProvider';

type Props = {};

const Rates = (props: Props) => {
  const { showToast } = useToast();
  const [rates, setRates] = useState<Partial<IMappedRate>[]>();
  const [savedRates, setSavedRates] = useState<Partial<IMappedRate>[]>();
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    getAllRate();
  }, []);

  const getAllRate = async () => {
    try {
      const { data } = await rateApi.getRateByYear(dayjs().format('YYYY'));
      setRates(data);
      setSavedRates(JSON.parse(JSON.stringify(data)));
    } catch (e) {
      showToast({
        message: 'Rate Fetch Failed',
        severity: 'danger',
      });
    }
  };

  const save = async () => {
    try {
      await rateApi.updateAllByDate(rates!);
      getAllRate();
      showToast({
        message: 'Rate Save Success',
        severity: 'success',
      });
    } catch (e) {
      showToast({
        message: 'Rate Save Failed',
        severity: 'danger',
      });
    }
  };

  return (
    <>
      <Breadcrumb crumb={['Rate']} />
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level='h2' component='h1'>
          Rate
        </Typography>
        <Box
          sx={{
            display: 'flex',
            mb: 1,
            gap: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            color='primary'
            onClick={async () => {
              if (edit === true) {
                await save();
              }
              setEdit((prev) => !prev);
            }}
            size='sm'
          >
            {edit ? 'Save' : 'Edit'}
          </Button>
          {edit && (
            <Button
              color='neutral'
              onClick={() => {
                setRates(JSON.parse(JSON.stringify(savedRates)));
                setEdit((prev) => !prev);
              }}
              size='sm'
            >
              Cancel
            </Button>
          )}
        </Box>
      </Box>
      {rates && (
        <>
          <RateTable
            rates={rates}
            edit={edit}
            onEdit={(date, key, value) => {
              let temp = [...rates];
              let index = temp.findIndex((obj) => obj.date === date);
              if (index !== -1) {
                temp[index][key] = value as any;
                setRates(temp);
              }
            }}
          />
        </>
      )}
    </>
  );
};

export default Rates;
